import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasAccessToken } from '@/lib/token-storage'
import { redirectToLoginApp } from '@/lib/login-app-url'

/**
 * Entrada alternativa do app: exige token; sem sessão envia ao app de login.
 * Com sessão, segue para a escolha de workspace.
 */
export const Route = createFileRoute('/(auth)/app')({
  beforeLoad: () => {
    if (!hasAccessToken()) {
      throw redirectToLoginApp()
    }
    throw redirect({ to: '/workspace' })
  },
})
